const { Form } = require("react-bootstrap");

const RadioField = ({
    isChecked,
    label,
    value,
    name,
    handleChange,
    customClass
}) => {
  return (
    <Form.Check
    className={`${customClass}`}
      type="radio"
      name={name}
      value={value}
      checked={isChecked}
      onChange={(e)=>handleChange(e)}
      label={label}
    />
  );
};

export default RadioField;
